<script lang="ts" setup>
import { ref, watch } from 'vue'
import RecommendRepository from './RecommendRepository.vue';
import { useElementVisibility } from '@vueuse/core'
import Loading from '@/home/components/Loading.vue';

const rep = ref(null)

const targetIsVisible = useElementVisibility(rep)

// 模拟数据
import { useFetch } from '@/home/hooks/fetch';
import { useAsyncData } from '@/home/hooks/async-data';

const { $fetch } = useFetch();
const recommendList = ref<any>([]);

let page = 1;
const finished = ref(false);

const { data: listing, pending, refresh } = useAsyncData(
  'home:tempalte3:repository',
  () => $fetch('/warehouse/home_warehouse_list', {
    method: 'post',
    data: {
      pageNum: page,
      pageSize: 10,
    },
  }),
  {
    cache: false,
    transform: (data) => data.records ?? [],
    onAfterHandle: () => {
      if (!recommendList.value.length) {
        recommendList.value = listing.value;
      }
    },
  },
);

// 加载更多数据的方法
const loadMoreData = async () => {
  if (finished.value) {
    return;
  }

  page++;

  await refresh(); // 等待数据刷新完成

  if (!listing.value.length) {
    finished.value = true;
    return;
  }

  // 将新数据追加到 recommendList 中
  recommendList.value.push(...listing.value);
}

watch(
  targetIsVisible,
  () => {
    if (targetIsVisible.value) {
      loadMoreData();
    }
  },
  { immediate: true },
)
</script>

<template>
  <section>
    <ul>
      <li v-for="(item, index) in recommendList" :key="index" class="bg-[#fff] px-24 hover:bg-[#3d7cfa] hover:bg-opacity-3">
        <RecommendRepository :data="item" />
      </li>
      <li class="flex-x-center color-gray-1" ref="rep" v-if="!finished">
        <Loading class="size-32" :show="pending" />
      </li>
    </ul>
  </section>
</template>

<style lang="scss" scoped>
</style>
